import { MenuItemEntry } from 'types/MenuItemEntry';

const findAllParent = (menuItems: MenuItemEntry[], menuItem: MenuItemEntry): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemEntry[] | undefined,
    menuItemKey: MenuItemEntry['key'] | undefined
): MenuItemEntry | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { findAllParent, findMenuItem };
